import React from "react";

export interface Param {
  name: string;
  type: string;
  required: boolean;
  description: string;
}

interface ParamTableProps {
  title: string;
  params: Param[];
}

export const ParamTable: React.FC<ParamTableProps> = ({ title, params }) => (
  <div className="mt-6">
    <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">{title}</h4>
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200">
            <th className="text-left px-4 py-2.5 text-gray-500 font-medium">Parameter</th>
            <th className="text-left px-4 py-2.5 text-gray-500 font-medium">Type</th>
            <th className="text-left px-4 py-2.5 text-gray-500 font-medium">Required</th>
            <th className="text-left px-4 py-2.5 text-gray-500 font-medium">Description</th>
          </tr>
        </thead>
        <tbody>
          {params.map((p, i) => (
            <tr key={p.name} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}>
              <td className="px-4 py-2.5 font-mono text-brand-main text-xs">{p.name}</td>
              <td className="px-4 py-2.5 text-gray-500 font-mono text-xs">{p.type}</td>
              <td className="px-4 py-2.5">
                <span
                  className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                    p.required
                      ? "bg-red-50 text-red-600"
                      : "bg-gray-100 text-gray-500"
                  }`}
                >
                  {p.required ? "Required" : "Optional"}
                </span>
              </td>
              <td className="px-4 py-2.5 text-gray-600 text-xs">{p.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);